import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import styles from "./MobileMenu.module.less";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { ConsoleSqlOutlined } from "@ant-design/icons";
import { useAuth } from "../components/hooks/useAuth";
import { isKougenClient } from "../utils/tenantCheck";

const MobileMenu = ({ openSidebar, toggleSidebar, onKougenToggle }: any) => {
  // const [togglerSidebar,setOnToggleSidebar] = useState(false);
  // const onToggleSidebar= ()=>{
  //     setOnToggleSidebar((prevState)=> !prevState);
  // }
  // console.log(window.location.pathname);
  const { auth } = useAuth();

  const { tenantId, user } = auth;

  const homePage = window.location.pathname === "/";
  const information = window.location.pathname === "/information";
  const manual = window.location.pathname === "/manual";
  const changePassword = window.location.pathname === "/change-password-2";

  const label = information
    ? "ユーザー情報"
    : manual
    ? "マニュアル表示"
    : changePassword
    ? "パスワード変更"
    : homePage
    ? "ホーム"
    : "ユーザー情報";

  return (
    <div>
      <div className={styles.container_layout}>
        <div className={styles.container_layout_inner}>
          <div style={{ maxWidth: "100%", paddingRight: "1rem" }}>
            {/* <span>{label}</span> */}
            {/* MobileMenu only for client */}
            {label === "ホーム" &&
            isKougenClient({ tenantId, user: "client" }) ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  justifyContent: "start",
                  width: "100%",
                }}
              >
                <span
                  style={{
                    fontSize: "1.25rem",
                    flex: "1 1 auto",
                    minWidth: "max-content",
                  }}
                >
                  {label}
                </span>
                <span
                  style={{
                    cursor: "pointer",
                    color: "blue",
                    fontSize: "0.6rem",
                    userSelect: "none",
                    textDecoration: "underline",
                    // textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    display: "inline-block",
                    flexGrow: 1,
                  }}
                  onClick={() => onKougenToggle(true)}
                  title="【重要】2025/1/13 システム不具合に関するお知らせとお詫び【不具合修正が完了いたしました】"
                >
                  【重要】2025/1/13 システム不具合に関する
                  <br />
                  お知らせとお詫び【不具合修正が完了いたしました】
                </span>
              </div>
            ) : (
              <span>{label}</span>
            )}
          </div>
          <div onClick={openSidebar}>
            <FontAwesomeIcon icon={faBars as IconProp} />
          </div>
        </div>
      </div>

      <div
        className={toggleSidebar ? styles.backdrop_open : styles.backdrop}
        onClick={openSidebar}
      ></div>
    </div>
  );
};

export default MobileMenu;
